import AssessmentTemplatesList from '@/views/shared/AssessmentTemplatesList'

function CompetencyTests() {
  return <AssessmentTemplatesList title='pages.competency_templates.create' type={2}/>
}

export default CompetencyTests